import React from 'react';
import core from '@gin-betting/core';

import './currency.scss';

const {
    utils: { getCurrency },
} = core;

const Currency: React.FC = () => {
    const { currencySymbol } = getCurrency();

    return (
        <span styleName="container" className="__app-Currency-container">
            {currencySymbol}
        </span>
    );
};

export default Currency;
